import { useState } from '#imports'

type HttpStore = {
  /**
   * The CSRF token used to prevent cross site request forgery attacks when
   * communicating with APIs.
   */
  csrf?: string
}

export const useHttpStore = () => {
  return useState<HttpStore>('HTTP_STORE', () => ({
    csrf: undefined,
  }))
}
